import { HttpMethods, makeRequest } from "../helpers/http.helper";
import { GetBookingScheduleQuery } from "../types/booking.type";

export const getBookingSchedule = (params: GetBookingScheduleQuery) => {
  return makeRequest({
    url: "/booking/schedule",
    method: HttpMethods.GET,
    params,
  });
};
